import {
  useAccountId,
  useBalance,
  useWallet
} from "@buidlerlabs/hashgraph-react-wallets";
import { Button, Group, Image, Stack, Text } from "@mantine/core";
import { URLs } from "../utils/constants";
import { showNotification } from "@mantine/notifications";
import { IconX } from "@tabler/icons";

export const ConnectedUserStats = () => {
  const { connector, disconnect } = useWallet();
  const { data: accountId } = useAccountId();
  const { data: balance } = useBalance();
  const icon = connector?.config?.icons?.white;

  const handleDisconnect = async () => {
    try {
      await fetch(`${URLs.API}/auth/logout`, {
        credentials: "include",
        method: "GET",
        redirect: "follow"
      });

      await disconnect();
    } catch (error) {
      console.error(error);

      showNotification({
        icon: <IconX />,
        autoClose: 4000,
        color: "red",
        title: `Could not disconnect`,
        message:
          error.message ??
          "Something went wrong the the account cannot be properly disconnected",
        loading: false
      });
    }
  };

  return (
    <Group>
      <Stack spacing={0}>
        <Text size={10} color="dimmed">
          AccountId: {accountId ?? "-"}
        </Text>
        <Text size={10} color="dimmed">
          Balance: {balance?.formatted ?? "-"}
        </Text>
      </Stack>
      <Button
        onClick={handleDisconnect}
        leftIcon={<Image width="auto" height={15} src={icon} />}
      >
        Disconnect
      </Button>
    </Group>
  );
};
